export const getSchoolPreference = (name) => {
  const schoolData = (window as any).school_data
  const pref = schoolData && schoolData.schoolPreferences[name]

  return pref && pref === 'true'
}
